import './scss/index.scss';
import { dcFactory } from 'dc';
import AudienceSelectorComponent from './js/audience-selector.component';

dcFactory.register(AudienceSelectorComponent);
